<h2 mat-dialog-title>{{ 'LiveStream.RequestToSpeakDialog.Title' | translate }}</h2>
<mat-dialog-content>
    <div class="content">
        <p>{{ 'LiveStream.RequestToSpeakDialog.Content' | translate }}</p>
        <p>{{ 'LiveStream.RequestToSpeakDialog.Instructions1' | translate }}</p>
        <img src="/assets/img/instructions_livestream_zoom.png" alt="Anleitung Zoom" />
        <p>{{ 'LiveStream.RequestToSpeakDialog.Instructions2' | translate }}</p>
    </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-stroked-button [mat-dialog-close]="false">{{ 'General.Cancel' | translate }}</button>
    <button mat-flat-button color="primary" [mat-dialog-close]="true">
        <mat-icon>record_voice_over</mat-icon>
        {{ 'LiveStream.RequestToSpeakDialog.Confirm' | translate }}
    </button>
</mat-dialog-actions>
